// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__3O-_-","icon":"Item_icon__3Co7X","title":"Item_title__2siyn","content":"Item_content__13Ftg"};